export default "__VITE_ASSET__40a6f619__"